<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">


                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                                    :to="{ path: '/adesao-plano', query: { page: $route.query.page } }" v-on="on" v-bind="attrs">
                                    Voltar
                                </v-btn>
                            </template>
                            <span>Voltar para a listagem</span>
                        </v-tooltip>
                    </div>

                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined">
                            <v-card-title class="card-group-title">Detalhes credor</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field dense label="Nome" :value="dataset.data.user.name" outlined
                                            hide-details="auto" disabled />
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-text-field dense label="CPF/CNPJ" :value="formattedRegistration" outlined
                                            hide-details="auto" disabled />
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field dense label="Email" :value="dataset.data.user.email" outlined
                                            hide-details="auto" disabled />
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-text-field dense label="Telefone" :value="dataset.data.user.phone_number"
                                            outlined hide-details="auto" disabled />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="4">
                                        <v-text-field dense label="Crédito" outlined
                                            hide-details="auto" disabled />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-text-field dense label="Moeda"
                                            outlined hide-details="auto" disabled />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-text-field dense label="Classe"
                                            outlined hide-details="auto" disabled />
                                    </v-col>
                                </v-row>
                                <v-row v-if="dataset.data && dataset.data.type">
                                    <v-col cols="12" sm="6">
                                        <v-text-field dense label="Classe" :value="getCreditorTypeName(dataset.data.type)" outlined
                                            hide-details="auto" disabled />
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row v-if="dataset.data && hasNameAuditAlert(dataset.data)" class="mt-0">
                    <v-col cols="12">
                        <v-alert dense outlined color="warning" icon="mdi-alert-outline" class="mb-0">
                            <div class="font-weight-bold mb-2">Divergência de nome identificada</div>
                            <div v-if="dataset.data.name_audit_details_parsed">
                                <div>
                                    <strong>Nome no momento da geração:</strong>
                                    {{ dataset.data.name_audit_details_parsed.generated_creditor_name || 'N/A' }}
                                </div>
                                <div>
                                    <strong>Nome atual do cadastro:</strong>
                                    {{ dataset.data.name_audit_details_parsed.current_creditor_name || 'N/A' }}
                                </div>
                                <div>
                                    <strong>Nome no termo:</strong>
                                    {{ dataset.data.name_audit_details_parsed.term_creditor_name || 'N/A' }}
                                </div>
                                <div>
                                    <strong>Nome da assinatura:</strong>
                                    {{ dataset.data.name_audit_details_parsed.validated_signature_name || 'N/A' }}
                                </div>
                                <div v-if="getActionableNameAuditIssues(dataset.data).length" class="mt-2">
                                    <strong>Alertas:</strong>
                                    <ul class="mb-0">
                                        <li v-for="(issue, index) in getActionableNameAuditIssues(dataset.data)" :key="index">
                                            {{ formatNameAuditIssue(issue) }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </v-alert>
                    </v-col>
                </v-row>

                <v-row class="mt-0">
                    <v-col cols="12">
                        <v-card class="card-form-outlined">
                            <v-card-title class="card-group-title">Detalhes Pagamento</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-alert dense outlined color="blue-grey" icon="mdi-currency-usd" class="mb-0 mt-n3">
                                            <div class="d-flex flex-column">
                                                <span class="caption blue-grey--text text--darken-1 font-weight-medium">
                                                    CREDOR OPTOU PELA
                                                </span>
                                                <span class="body-2 font-weight-bold mt-1">
                                                    {{ getPlanOptionLabel(dataset.data.plan_option) }}
                                                </span>
                                            </div>
                                        </v-alert>
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-alert v-if="dataset.data.interest_plan_option != null" dense outlined
                                            color="orange darken-1" icon="mdi-swap-horizontal-circle-outline"
                                            class="mb-0 mt-n3">
                                            <div class="d-flex flex-column">
                                                <span class="caption orange--text text--darken-2 font-weight-medium">
                                                    CREDOR MANIFESTOU INTERESSE EM TROCAR PARA
                                                </span>
                                                <span class="body-2 font-weight-bold mt-1">
                                                    {{ getPlanOptionLabel(dataset.data.interest_plan_option) }}
                                                </span>
                                            </div>
                                        </v-alert>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row v-if="dataset.data && dataset.data.uploaded_doc" class="mt-0">
                    <v-col cols="12">
                        <v-card flat outlined class="pa-4">
                            <h3 class="mb-4">Detalhes assinatura digital</h3>
                            <v-card class="mb-4 pa-3" flat outlined>
                                <v-row>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>Nome:</strong> {{ dataset.data.signer_name || '' }} </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>Email:</strong> {{ dataset.data.signer_email || '' }} </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>CPF/CNPJ:</strong> {{ formatCpfCnpj (dataset.data.signer_registration) || '' }}
                                        </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>Certificado válido de:</strong> {{ dataset.data.cert_valid_from |
                                            defaultDate('DD/MM/YYYY HH:mm:ss') }} </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span><strong>Certificadao válido até:</strong> {{ dataset.data.cert_valid_to |
                                            defaultDate('DD/MM/YYYY HH:mm:ss') }}</span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span><strong>Enviado em:</strong> {{ dataset.data.uploaded_at |
                                            defaultDate('DD/MM/YYYY HH:mm:ss') }}</span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span><strong>Resultado:</strong> {{ dataset.data.validation_result || ''
                                            }}</span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span><strong>Status:</strong></span>
                                        <v-chip class="ml-2" :color="getStatusColor(dataset.data.status)"
                                            text-color="white" small>
                                            {{ getStatusText(dataset.data.status) }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                                <br>
                            </v-card>

                            <v-card v-if="dataset.data && dataset.data.issuerDetails" class="mb-4 pa-3" flat outlined>
                                <!-- <h4 class="mb-2">Emissor:</h4> -->
                                <v-row>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>País:</strong> {{ dataset.data.issuerDetails.c || '' }} </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>Emissor:</strong> {{ dataset.data.issuerDetails.cn || '' }}
                                        </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>Organização:</strong> {{ dataset.data.issuerDetails.o || '' }}
                                        </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>Unidade:</strong> {{ dataset.data.issuerDetails.ou || '' }}
                                        </span>
                                    </v-col>
                                </v-row>
                                <br>
                            </v-card>

                            <v-alert v-else type="info" color="warning" outlined icon="mdi-clock-outline">
                                <template v-slot:prepend>
                                    <v-icon color="grey darken-4">mdi-clock-outline</v-icon>
                                </template>
                                <span class="text--primary ml-3">O credor ainda não enviou arquivo assinado.</span>
                            </v-alert>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row class="mt-4 ml-3">
            <v-col cols="12">
                <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                    <div
                    style="display: inline-block;"
                    v-bind="attrs"
                    v-on="on"
                    >
                    <v-switch
                        :loading="isSaving"
                        v-model="dataset.data.reviewed"
                        color="green"
                        :label="dataset.data.reviewed ? 'Documento revisado' : 'Documento ainda não revisado'"
                        @change="onToggleReviewed"
                    />
                    </div>
                </template>

                <span>
                    {{ dataset.data.reviewed
                        ? 'Este documento foi marcado como revisado.'
                        : 'Marque quando a revisão estiver concluída.' }}
                </span>
                </v-tooltip>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined">
                            <v-card-title class="card-group-title">Detalhes documento</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col v-if="dataset.data && dataset.data.generated_doc" class="doc-info" cols="12"
                                        sm="3">
                                        <span>Documento PDF - Gerado</span>
                                    </v-col>
                                    <v-col v-if="dataset.data && dataset.data.uploaded_doc" class="doc-info" cols="12"
                                        sm="3">
                                        <span>Documento PDF - Enviado</span>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="3">
                                        <iframe
                                            :src="typeof dataset.data.generated_doc_url === 'string' ? dataset.data.generated_doc_url : null"
                                            width="250" height="150" frameborder="0" scrolling="no" class="rounded-xl">
                                        </iframe>
                                    </v-col>

                                    <v-col cols="12" sm="3">
                                        <iframe
                                            :src="typeof dataset.data.uploaded_doc_url === 'string' ? dataset.data.uploaded_doc_url : null"
                                            width="250" height="150" frameborder="0" scrolling="no" class="rounded-xl">
                                        </iframe>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col v-if="dataset.data && dataset.data.generated_doc" cols="12" sm="3">
                                        <v-btn type="button" elevation="0" color="primary" outlined
                                            :href="typeof dataset.data.generated_doc_url === 'string' ? dataset.data.generated_doc_url : null"
                                            target="_blank">
                                            Visualizar documento
                                        </v-btn>
                                    </v-col>

                                    <v-col v-if="dataset.data && dataset.data.uploaded_doc" cols="12" sm="3">
                                        <v-btn type="button" elevation="0" color="primary" outlined
                                            :href="typeof dataset.data.uploaded_doc_url === 'string' ? dataset.data.uploaded_doc_url : null"
                                            target="_blank">
                                            Visualizar documento
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>



    </v-container>
</template>

<script>
import states from "@/common/data/states.data"
import string from "@/common/util/string"
import creditorTypes from "@/common/data/creditor-types.data"
import planAdherenceOptions from "@/common/data/adherence-term-option.data"

import axios from "axios"

import { cpf, cnpj } from 'cpf-cnpj-validator'

export default {
    name: "PlanAdherenceDetails",
   
    data: () => ({
        user: null,
        isSaving: false,
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            creditorTypes: creditorTypes,
            planAdherenceOptions: planAdherenceOptions,
            breadcrumbItems: [],
            data: {
                user: {
                    name: '',
                    registrtration: '',
                },
                reviewed: false,
                issuerDetails: '',
            },
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
        },
       
    }),

    computed: {
        formattedRegistration() {
            const registration = this.dataset.data.user.registration;
            if (!registration) return '';

            return registration.length < 14
            ? cpf.format(registration)
            : cnpj.format(registration);
        }
    },

    created() {
        this.currentPage = this.$route.query.page || 1
        this.loadData()
    },

    methods: {
        goBack() {
            this.$router.replace("/adesao-plano");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();
            this.user = this.$root.user.data || this.$root.user;
            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `${this.page.isNew ? 'Nova Adesão ao Plano' : 'Detalhes da Adesão ao Plano'}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Adesão ao plano",
                disabled: false,
                to: "/adesao-plano",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        async onToggleReviewed(value) {
            
            this.isSaving = true;

            try {
               
                await axios.post(`/api/admin/plan-adherence/review/${this.dataset.data.id}`);

                this.$dialog.notify.success("Status de revisão atualizado com sucesso!", {
                    position: 'top-right',
                    timeout: 3000
                });

            } catch (e) {
                console.error("Erro ao alterar revisão");
            }

            this.isSaving = false;
            
            this.load();
        },

        formatCpfCnpj(value) {
            if (!value) return "";
            
            const clean = value.toString().replace(/\D/g, "");

            if (clean.length === 11) {
                return cpf.format(clean);
            }
            if (clean.length === 14) {
                return cnpj.format(clean);
            }

            return value; 
        },

        getCreditorTypeName(typeId) {
            const type = this.dataset.creditorTypes.find(item => item.id === typeId);
            return type ? type.name : 'N/A';
        },
        
        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/plan-adherence/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = data;

               if (data.cert_issuer_details) {
                    try {
                        this.dataset.data.issuerDetails = JSON.parse(data.cert_issuer_details);
                    } catch (e) {
                        this.dataset.data.issuerDetails = null;
                    }
                } else {
                    this.dataset.data.issuerDetails = null;
                }

                if(this.dataset && this.dataset.data){
                    this.dataset.data.reviewed = !!this.dataset.data.reviewed_at;
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        getStatusText(status) {
            switch (status) {
            case 0:
                return 'Pendente';
            case 1:
                return 'Aprovado';
            case 2:
                return 'Rejeitado';
            default:
                return 'Desconhecido';
            }
        },

        getStatusColor(status) {
            switch (status) {
            case 0:
                return 'orange';
            case 1:
                return 'green';
            case 2:
                return 'red';
            default:
                return 'grey';
            }
        },

        getPlanOptionLabel(value) {
           if (value === null || value === undefined) return 'N/A';

           const options = this.dataset.planAdherenceOptions[3] || [];
           const found = options.find(o => o.value === value);
          
           return found ? found.text : 'N/A';
       },

        hasNameAuditAlert(item) {
            if (!item) return false;
            if (this.getNameAuditIssues(item).some(issue => this.getNameAuditIssueSeverity(issue))) return true;
            return !!(item.name_audit_runtime_alert || item.name_audit_alert);
        },

        getNameAuditIssues(item) {
            const details = item && item.name_audit_details_parsed ? item.name_audit_details_parsed : {};
            return Array.isArray(details.issues) ? details.issues : [];
        },

        getActionableNameAuditIssues(item) {
            return this.getNameAuditIssues(item).filter(issue => this.getNameAuditIssueSeverity(issue));
        },

        formatNameAuditIssue(issue) {
            if (!issue || !issue.type) return 'Divergência identificada.';

            if (issue.type === 'creditor_name_changed_after_generation') {
                return `${this.getNameAuditClassificationLabel(issue)}: PDF "${issue.generated_name || 'N/A'}" <> cadastro atual "${issue.current_name || 'N/A'}"`;
            }

            if (issue.type === 'signer_name_differs_from_generation_snapshot') {
                return `${this.getNameAuditClassificationLabel(issue)}: assinatura "${issue.signer_name || 'N/A'}" <> ${issue.role || 'assinante esperado'} "${issue.generated_name || 'N/A'}"`;
            }

            if (issue.left_value || issue.right_value) {
                return `${this.getNameAuditClassificationLabel(issue)}: ${issue.left_label || 'Origem 1'} "${issue.left_value || 'N/A'}" <> ${issue.right_label || 'Origem 2'} "${issue.right_value || 'N/A'}"`;
            }

            if (issue.type === 'signature_provider_not_gov_br') {
                return `Assinatura realizada com certificado diferente de GOV.BR: ${issue.provider || 'N/A'}${issue.signer_name ? ` - ${issue.signer_name}` : ''}`;
            }

            return issue.type;
        },

        normalizeNameForAudit(value) {
            return String(value || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toUpperCase()
                .replace(/[^A-Z0-9\s]/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
        },

        getNameTokensForAudit(value) {
            const connectors = ['DA', 'DE', 'DO', 'DAS', 'DOS', 'E', 'DEL', 'DELLA', 'DI', 'DU'];
            return this.normalizeNameForAudit(value)
                .split(' ')
                .filter(token => token && !connectors.includes(token));
        },

        getLevenshteinDistance(left, right) {
            if (left === right) return 0;
            if (!left) return right.length;
            if (!right) return left.length;

            let previous = Array.from({ length: right.length + 1 }, (_, index) => index);

            for (let i = 1; i <= left.length; i += 1) {
                const current = [i];

                for (let j = 1; j <= right.length; j += 1) {
                    current[j] = Math.min(
                        previous[j] + 1,
                        current[j - 1] + 1,
                        previous[j - 1] + (left[i - 1] === right[j - 1] ? 0 : 1)
                    );
                }

                previous = current;
            }

            return previous[right.length];
        },

        classifyNameAuditDifference(left, right) {
            const normalizedLeft = this.normalizeNameForAudit(left);
            const normalizedRight = this.normalizeNameForAudit(right);

            if (!normalizedLeft || !normalizedRight) return 'missing_or_unreadable_name';
            if (normalizedLeft === normalizedRight && String(left || '') !== String(right || '')) return 'accent_or_punctuation_only';
            if (normalizedLeft === normalizedRight) return 'same_after_normalization';

            const leftTokens = this.getNameTokensForAudit(left);
            const rightTokens = this.getNameTokensForAudit(right);
            const rightTokenSet = new Set(rightTokens);
            let common = 0;
            let initialMatches = 0;
            let typoMatches = 0;

            for (const token of leftTokens) {
                if (rightTokenSet.has(token)) {
                    common += 1;
                    continue;
                }

                if (token.length === 1 && rightTokens.some(rightToken => rightToken.startsWith(token))) {
                    initialMatches += 1;
                    continue;
                }

                if (rightTokens.some(rightToken => rightToken.length === 1 && token.startsWith(rightToken))) {
                    initialMatches += 1;
                    continue;
                }

                if (rightTokens.some(rightToken => Math.max(token.length, rightToken.length) >= 5 && this.getLevenshteinDistance(token, rightToken) <= 1)) {
                    typoMatches += 1;
                }
            }

            const minLength = Math.min(leftTokens.length, rightTokens.length) || 1;
            const maxLength = Math.max(leftTokens.length, rightTokens.length) || 1;
            const aligned = common + initialMatches + typoMatches;

            if (common === 0 && initialMatches === 0 && typoMatches === 0) return 'completely_different_name';
            if (common === leftTokens.length && common === rightTokens.length) return 'same_after_normalization';
            if (initialMatches && aligned >= minLength && common >= 1) return 'abbreviation_or_initial';
            if (typoMatches && aligned >= minLength && common >= 1) return 'probable_typo_or_spelling_variation';
            if (common >= minLength && maxLength - minLength <= 2) return 'partial_or_missing_middle_name';
            if (common / maxLength < 0.34) return 'mostly_different_name';

            return 'substantial_name_difference';
        },

        getNameAuditIssueClassification(issue) {
            if (!issue) return null;
            if (issue.classification) return issue.classification;

            if (issue.type === 'creditor_name_changed_after_generation') {
                return this.classifyNameAuditDifference(issue.generated_name, issue.current_name);
            }

            if (issue.type === 'signer_name_differs_from_generation_snapshot') {
                return this.classifyNameAuditDifference(issue.generated_name, issue.signer_name);
            }

            if (issue.left_value || issue.right_value) {
                return this.classifyNameAuditDifference(issue.left_value, issue.right_value);
            }

            return null;
        },

        getNameAuditIssueSeverity(issue) {
            if (!issue) return null;
            if (issue.type === 'signature_provider_not_gov_br') return 'critical';
            if (issue.severity) return issue.severity;
            if (issue.type === 'generated_signers_snapshot_parse_error') return 'medium';

            const classification = this.getNameAuditIssueClassification(issue);

            if (['same_after_normalization', 'accent_or_punctuation_only'].includes(classification)) return null;

            if ([
                'partial_or_missing_middle_name',
                'abbreviation_or_initial',
                'probable_typo_or_spelling_variation',
            ].includes(classification)) {
                return 'low';
            }

            if (classification === 'substantial_name_difference') return 'medium';

            if (classification) return 'critical';

            return null;
        },

        getNameAuditClassificationLabel(issue) {
            const classification = this.getNameAuditIssueClassification(issue);

            const labels = {
                partial_or_missing_middle_name: 'Variação por sobrenome intermediário',
                abbreviation_or_initial: 'Variação por abreviação/inicial',
                probable_typo_or_spelling_variation: 'Provável typo ou variação de escrita',
                substantial_name_difference: 'Diferença substancial',
                mostly_different_name: 'Nome majoritariamente diferente',
                completely_different_name: 'Nome completamente divergente',
                missing_or_unreadable_name: 'Nome ausente ou ilegível',
            };

            return labels[classification] || 'Divergência de nome';
        },
    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
